import { GridColDef } from '@fashionnovateam/nova-ui-toolkit';
import { InspoTableColumns } from '../../types/TableColumns';

export const columns: GridColDef[] = [
  {
    field: InspoTableColumns.PHOTO,
    headerName: 'Photo',
    render: 'photo',
    display: 'flex',
    align: 'center',
    minWidth: 72,
    width: 72,
    disableColumnMenu: true,
    sortable: false,
    resizable: false,
  },
  {
    field: InspoTableColumns.LAST_MESSAGE,
    headerName: 'Last Message',
    render: 'custom',
    sortable: true,
    minWidth: 200,
    width: 200,
  },
  {
    field: InspoTableColumns.PRIORITY,
    headerName: 'Priority',
    render: 'badge',
    sortable: true,
    minWidth: 170,
    width: 170,
  },
  {
    field: InspoTableColumns.TEAM_MEMBERS,
    headerName: 'Team Members',
    render: 'custom',
    display: 'flex',
    sortable: false,
  },
  {
    field: InspoTableColumns.FN_CONTACTS,
    headerName: 'FN Contacts',
    render: 'custom',
    display: 'flex',
    sortable: false,
  },
  {
    field: InspoTableColumns.ALIAS,
    headerName: 'Alias',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.CATEGORY,
    headerName: 'Category',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.KEY_DETAILS,
    headerName: 'Key Details',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: InspoTableColumns.REQUESTED_ON,
    headerName: 'Requested On',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 150,
  },
  {
    field: InspoTableColumns.VENDOR_SAMPLE_STATUS,
    headerName: 'Vendor Sample Status',
    render: 'badge',
    display: 'flex',
    sortable: false,
    minWidth: 200,
  },
  {
    field: InspoTableColumns.VENDOR_SAMPLE_SHIPPED,
    headerName: 'Vendor Sample Shipped',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 170,
  },
  {
    field: InspoTableColumns.VENDOR_SAMPLE_TRACKING,
    headerName: 'Vendor Sample Tracking',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: InspoTableColumns.VENDOR_SAMPLE_RECEIVED,
    headerName: 'Vendor Sample Received',
    render: 'custom',
    display: 'flex',
    sortable: false,
    minWidth: 150,
  },
  {
    field: InspoTableColumns.QUOTE_STATUS,
    headerName: 'Quote Status',
    render: 'badge',
    sortable: false,
    minWidth: 200,
  },
  {
    field: InspoTableColumns.QTY_RANGE,
    headerName: 'Quantity Range',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.JR_COST,
    headerName: 'JR Cost',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.PLUS_COST,
    headerName: 'Plus Cost',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.MOQ,
    headerName: 'MOQ',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.MCQ,
    headerName: 'MCQ',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.COO,
    headerName: 'COO',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.SHIPMENT_MODE,
    headerName: 'Shipment Mode',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.FABRIC_CONTENT,
    headerName: 'Fabric Content',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.FABRIC_WEIGHT,
    headerName: 'Fabric Weight',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.FABRIC_CODE_AND_NAME,
    headerName: 'Fabric Name',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.FABRIC_TYPE,
    headerName: 'Fabric Type',
    render: 'string',
    display: 'flex',
    sortable: false,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.LEAD_TIME,
    headerName: 'Lead Time',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.REORDER_LEAD_TIME,
    headerName: 'Reorder Lead Time',
    render: 'string',
    display: 'flex',
    sortable: true,
    minWidth: 120,
  },
  {
    field: InspoTableColumns.ACTIONS,
    headerName: 'Actions',
    render: 'custom',
    sortable: false,
    minWidth: 200,
  },
];
